// import { axiosPrivate } from "api/axios";
// import { AUTH_TOKEN } from "constants/AuthConstant";


// const DashBoardsServices = {};

// DashBoardsServices.getAllUsers = function () {
//   return axiosPrivate({
//     url: "/Dashboards/allUsers",
//     method: "get",
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };
// DashBoardsServices.getNannyCategory = function () {
//   return axiosPrivate({
//     url: "/Dashboards/nanniesCategory",
//     method: "get",
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };
// DashBoardsServices.getParentCategory = function () {
//   return axiosPrivate({
//     url: "Dashboards/allParents",
//     method: "get",
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };
// DashBoardsServices.getNannyRating = function () {
//   return axiosPrivate({
//     url: "/Dashboards/babySitterRatings",
//     method: "get",
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };



// export default DashBoardsServices;






import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const DashBoardsServices = {};

DashBoardsServices.getAllUsers = function () {
  return axiosPrivate({
    url: "/Dashboards/allUsers",
    method: "get",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

DashBoardsServices.getNannyCategory = function () {
  return axiosPrivate({
    url: "/Dashboards/nanniesCategory",
    method: "get",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

DashBoardsServices.getParentCategory = function () {
  return axiosPrivate({
    url: "/Dashboards/allParents",
    method: "get",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

DashBoardsServices.getNannyRating = function () {
  return axiosPrivate({
    url: "/Dashboards/babySitterRatings",
    method: "get",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default DashBoardsServices;